// extracted by mini-css-extract-plugin
export default {"container":"container__VariantConsequence__x1aIx"};